import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: '100%',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export default function ThankYou(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        // direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Typography
              variant="h6"
            >
              ありがとうございます。またのお越しをお待ちしております。
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
